import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5464_9765)">
      <path
        d="M0.25 3.83374L5.11237 11.2616H11.4117L9.98094 9.07495H14.5216L9.10162 17.3571L12.25 22.1662L24.25 3.83374L0.25 3.83374Z"
        fill="#11181C"
      />
    </g>
    <defs>
      <clipPath id="clip0_5464_9765">
        <rect width="24" height="24" fill="white" transform="translate(0.25)" />
      </clipPath>
    </defs>
  </svg>
)
